import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  greenText: {
    color: theme.palette.green.color,
  },
  redText: {
    color: theme.palette.red.color,
  },
  yellowText: {
    color: theme.palette.yellow.color,
  }
}))
